import Swiper  from 'swiper';
import {Autoplay, Navigation, Pagination} from 'swiper/modules';
import {getOptionsFromJsonString} from "./utilities/options";

export function initSlideshows(query = document.querySelectorAll('.slideshow')) {
    for (let slideshow of query) {
        let options = getOptionsFromJsonString(slideshow.dataset.options, {
            autoplay_interval: 5000,
            eff_interval: 300,
        });

        function updatePaginationPosition() {
            if (window.innerWidth < 768 && slideshow.classList.contains("slideshow--3")) {
                let contentText = slideshow.querySelector('.contentText');
                let pagination = slideshow.querySelector('.swiper-pagination');

                if (contentText && pagination) {
                    let contentHeight = contentText.offsetHeight;
                    let paginationPosition = contentHeight - 44;
                    pagination.style.top = `${paginationPosition}px`;
                }
            } else if (slideshow.classList.contains("slideshow--3")) {
                let pagination = slideshow.querySelector('.swiper-pagination');
                if (pagination) {
                    pagination.style.top = '';
                }
            }
        }

        if (slideshow.classList.contains("slideshow--3")) {
            Swiper.use([Autoplay, Pagination]);
            new Swiper(slideshow, {
                loop: true,
                items: 1,
                speed: options.eff_interval,
                autoplay: {
                    delay: options.autoplay_interval,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                on: {
                    init: updatePaginationPosition,
                }
            });
        } else {
            Swiper.use([Autoplay, Navigation]);
            new Swiper(slideshow, {
                loop: true,
                items: 1,
                speed: options.eff_interval,
                autoplay: {
                    delay: options.autoplay_interval,
                },
                navigation: {
                    nextEl: slideshow.querySelector('.swiper-button-next'),
                    prevEl: slideshow.querySelector('.swiper-button-prev'),
                }
            });
        }
    }

    const breakpoint = window.matchMedia("(max-width: 1024px)");
    let swiperInstance;

    const enableSwiper = () => {
        if (!swiperInstance) {
            const bannerGroup = document.querySelector(".bannerGroup");
            const banners = document.querySelectorAll(".bannerGroup > .banner:nth-child(2), .bannerGroup > .banner:nth-child(3), .bannerGroup > .banner:nth-child(4)");

            const swiperContainer = document.createElement("div");
            swiperContainer.classList.add("swiper", "bannerGroupSwiper");

            const swiperWrapper = document.createElement("div");
            swiperWrapper.classList.add("swiper-wrapper");

            banners.forEach((banner) => {
                banner.classList.add("swiper-slide");
                swiperWrapper.appendChild(banner);
            });

            const swiperPagination = document.createElement("div");
            swiperPagination.classList.add("swiper-pagination");

            swiperContainer.appendChild(swiperWrapper);
            swiperContainer.appendChild(swiperPagination);

            const firstBanner = document.querySelector(".bannerGroup > .banner:first-child");
            if (firstBanner){
                firstBanner.insertAdjacentElement("afterend", swiperContainer);
            }

            swiperInstance = new Swiper(".bannerGroupSwiper", {
                slidesPerView: "auto",
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            });
        }
    };

    const disableSwiper = () => {
        if (swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;

            const swiperContainer = document.querySelector(".bannerGroupSwiper");
            if (swiperContainer) {
                const banners = swiperContainer.querySelectorAll(".swiper-slide");
                const bannerGroup = document.querySelector(".bannerGroup");
                const firstBanner = document.querySelector(".bannerGroup > .banner:first-child");

                banners.forEach((banner) => {
                    banner.classList.remove("swiper-slide");
                    firstBanner.insertAdjacentElement("afterend", banner);
                });

                swiperContainer.remove();
            }
        }
    };

    const breakpointChecker = () => {
        if (breakpoint.matches) {
            enableSwiper();
        } else {
            disableSwiper();
        }
    };

    breakpoint.addEventListener("change", breakpointChecker);
    breakpointChecker();

}
